import { INDENT } from '@yme/tokens/sizes';
export const PRODUCT_CARD_SECTION_ID = 'product_card_section';
export const PDP_CARD_UNITS_DATA_ID = 'pdp_units-card';
const defaultGallerySettings = {
    isControlsAvailable: true,
    isSquareRatio: true,
    thumbnailsAmount: {
        desktop: 7,
        smallDesktop: 7,
        tablet: 7,
        mobile: 4,
    },
    thumbnailsIndent: {
        desktop: INDENT.xs,
        smallDesktop: INDENT.xs,
        tablet: INDENT.xs,
        mobile: INDENT.xs,
    },
};
export const GALLERY_CONFIG = {
    isExpandAvailable: true,
    ...defaultGallerySettings,
};
export const ACCESSORIES_GALLERY_CONFIG = {
    isExpandAvailable: false,
    ...defaultGallerySettings,
};
export const DEFAULT_PRODUCT_CARD_MARGIN_TOP_MOBILE = 24;
export const DEFAULT_PRODUCT_CARD__MARGIN_TOP_TABLET = 24;
export const DEFAULT_PRODUCT_CARD__MARGIN_TOP_DESKTOP = 48;
